import { MDBContainer } from "mdb-react-ui-kit";
import { useContext } from "react";
import { TranslationContext } from "../../context/translations/translations-context";
import { useCurrentUserRoles } from "../../hooks/useCurrentUserRoles";
import useResumeProperties from "../../hooks/useResumeProperties";
import CssfFooter from "./cssf/CssfFooter";
import CssfHeader from "./cssf/CssfHeader";
import CssfMainContent from "./cssf/CssfMainContent";
import Footer from "./non-cssf/Footer";
import Header from "./non-cssf/Header";
import MainContent from "./non-cssf/MainContent";

export default function ResumePreview() {
    const { translations } = useContext( TranslationContext );
    const { isCssf, keywords } = useResumeProperties();
    const { isClientRole } = useCurrentUserRoles();

    return (
        <>
            <div className={ `row ${ isClientRole ? 'hide-for-client' : '' }` }>
                EditionCV: 2197-2307
            </div>
            <div className={ `text-white text-center py-3 ${ isClientRole ? 'hide-for-client' : '' }` }>
                <p>
                    { translations.topRightSection.resumeNameLabel }
                    { ' ' }
                    { keywords.join( ", " ) || "" }
                </p>
            </div>
            <div>
                <MDBContainer fluid className="card cv-preview-pdf">
                    { isCssf ? (
                        <>
                            <CssfHeader/>
                            <CssfMainContent/>
                            <CssfFooter/>
                        </>
                    ) : (
                        <>
                            <Header/>
                            <MainContent/>
                            <Footer/>
                        </>
                    ) }
                </MDBContainer>
            </div>
        </>
    );
}